export default function parseJSON(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    // For debugging
    // console.log(e, typeof value, value);
  }
  return value;
}
